const config = { attributes: true, childList: true, subtree: true };

const callback = (mutationList, observer) => {
  const messages = document.querySelectorAll('.bss-lock-element');
  messages.forEach(message => {
    const ltspMessage = message.querySelector('.bss-lock-message-element-5358');
    if (ltspMessage && ltspMessage.href !== 'https://makelab.gr/pages/registration') {
        ltspMessage.href = 'https://makelab.gr/pages/registration'
    }
    const accessDeniedMessage = message.querySelector('.bss-lock-price-access-deniend-5358');
    if (accessDeniedMessage && accessDeniedMessage.href !== 'https://makelab.gr/pages/registration') {
        accessDeniedMessage.href = 'https://makelab.gr/pages/registration'
    }
  });
};

const observer = new MutationObserver(callback);

observer.observe(document.body, config);
